import { render, staticRenderFns } from "./CurrentEmployeeNotes.vue?vue&type=template&id=5696dde4&scoped=true&"
import script from "./CurrentEmployeeNotes.vue?vue&type=script&lang=js&"
export * from "./CurrentEmployeeNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5696dde4",
  null
  
)

export default component.exports